module.exports = __webpack_public_path__ + "static/media/duplicate-icon.befd74cb.svg";